app.service('passwordRecovery', (pageConfig, modal, validate, captchaService, log) => {
	let passwordRecoveryUrl;
	let email;
	function requestPasswordRecoveryForm() {
		return $.ajax(passwordRecoveryUrl);
	}

	function onValidationSuccess(form) {
		const $passwordRecovery = $('#password-recovery');
		$passwordRecovery.addClass('loading');
		email = $("#reminder-email").val();
		log.event({
			id: 'password-recovery-send',
			f03: email
		});
		$(form).ajaxSubmit({
			url: passwordRecoveryUrl,
			success: function (html) {
				$passwordRecovery.removeClass('loading');
				modal.alert(html);
				log.event({
					id: 'password-recovery-success',
					f03: email
				});
			},
			error: function () {
				log.event({
					id: 'password-recovery-error',
					f03: email
				});
				$passwordRecovery.removeClass('loading');
				modal.alert('Wystapił błąd. Prosimy spróbować później');
			}
		});
	}

	function attachValidation() {
		passwordRecoveryCaptcha();
		validate.task('passwordRecovery', function (form) {
			onValidationSuccess(form);
		});
	}

	function generateModal(content) {
		const defer = $.Deferred();

		modal.generate({
			header: 'Przypomnij hasło',
			content,
			modifier: 'remodal-full-width',
			id: 'password-recovery-modal',
			callbackOpen: () => defer.resolve()
		});

		return defer.promise();
	}

	function handlePasswordRecoveryClick(e) {
		e.preventDefault();
		log.event({
			id: 'password-recovery-open',
			f03: document.location.href
		});
		requestPasswordRecoveryForm()
			.then(generateModal)
			.then(attachValidation)
			.then(copyEmailAdress);
	}

	function copyEmailAdress() {
		$("#reminder-email").val($("#login-username").val()).focus();

	}

	function passwordRecoveryCaptcha() {
		const $captcha = $('#password-recovery-captcha');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	let isOneInit = false;
	function init() {
		let config = pageConfig.getData('order');
		passwordRecoveryUrl = config && config.giftCardOrderPath ? '/gift-card-password-recovery-form.ltr' : '/password-recovery-form.ltr';
		
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-password-recovery', handlePasswordRecoveryClick);
		}
	}

	return { init };
});
